import React from 'react'
import { useText, textApplyVariables } from '../context/TextContext'
import { FormSelect } from 'react-bootstrap';
import { useUser } from '../context/UserContext';
import { toast } from 'react-toastify';
import useQueryParam from '../hooks/useQueryParams';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { getBrowserLanguage, LANGUAGE_OPTIONS } from '../utils/presentation';
import Gravatar from '../components/Gravatar';
import { AdvancedButton } from '../components/AdvancedButton';
import { UserSettings } from '../models/shared/User';

export default function UserPreferencesPage() {
    const text = useText();
    const { user, updateUser } = useUser();
    const [processing, setProcessing] = React.useState(false);
    const [accountSettings, setAccountSettings] = React.useState<UserSettings>(user?.settings || {});
    const { back } = useQueryParam();
    const navigate = useNavigate();

    const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        return handleUpdateSettings();
    }
    const handleUpdateSettings = async () => {
        setProcessing(true);
        try {
            await updateUser({ settings: accountSettings });
            toast.success(text.defaultSuccess);
            if (back) {
                navigate(-1);
            }
        } catch (error) {
            console.error(error);
            toast.error(text.defaultError);
        }
        setProcessing(false);
    }

    return (
        <>
            <PageHeader title={text.userPreferences} description={text.accountSettingsDescription} showBackButton={!!back}
                actions={[{
                    icon: 'bi-floppy',
                    text: text.save,
                    processing: processing,
                    onClick: handleUpdateSettings,
                }]}
            />
            <form onSubmit={handleFormSubmit}>
                <div className='d-flex flex-column gap-4'>
                    <div className='d-flex flex-column gap-2'>
                        <div className='d-flex align-items-center gap-3'>
                            <a href="https://gravatar.com/profile" target="_blank" rel="noopener noreferrer">
                                <Gravatar identifier={user?.email} size='sm' default='wavatar' />
                            </a>
                            <span>{user?.email}</span>
                            <AdvancedButton
                                href="https://gravatar.com/profile" hrefBlank icon="bi-person-circle"
                                variant="outline-primary"> {text.changeAvatar}
                            </AdvancedButton>
                        </div>
                        <p className='text-muted mb-0'>
                            {textApplyVariables(text.avatarLinkedToGravatar, { email: user?.email || '' })}<br />
                            {text.avatarUpdateTime}
                        </p>
                    </div>
                    <div>
                        <div className='d-flex flex-column align-items-start mt-2 gap-2'>
                            <div>
                                <label>{text.language}</label>
                                <p className='text-muted small m-0'>{text.languageDescription}</p>
                            </div>
                            <FormSelect value={accountSettings.language || getBrowserLanguage()} className='w-unset'
                                onChange={(e: any) => setAccountSettings({ ...accountSettings, language: e.target.value })}
                            >
                                {LANGUAGE_OPTIONS.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                ))}
                            </FormSelect>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
